import { FC } from 'react'
import { CreateButton } from 'react-admin'
import { RestrictedButton } from './RestrictedButton'

/** Create button of a list, only for users with the write scope. */
export const RestrictedCreateButton: FC<{ scope: string }> = ({ scope }) => (
  <RestrictedButton access={[scope]} align="right">
    {(): JSX.Element => <CreateButton variant="contained" />}
  </RestrictedButton>
)
